import React, { useState } from "react";
import "./Home.css";
import Product from "./Product";
import Carousel from "react-bootstrap/Carousel";
import AdSense from "react-adsense";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <Carousel className="carousel__container">
          <Carousel.Item>
            <img
              className="home__image"
              src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
              alt="First slide"
            />
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="home__image"
              src="https://m.media-amazon.com/images/I/61VdiCqXFlL._SX3000_.jpg"
              alt="Second Slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="home__image"
              src="https://m.media-amazon.com/images/I/710Hk90VZvL._SX3740_.jpg"
              alt="Third Slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="home__image"
              src="https://m.media-amazon.com/images/I/71-Qb97tvdL._SX3740_.jpg"
              alt="Fourth Slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="home__image"
              src="https://m.media-amazon.com/images/I/61N6u7SOYGL._SX3000_.jpg"
              alt="Fifth slide"
            />
          </Carousel.Item>
        </Carousel>

        <div className="home__row">
          <Product
            id="12321341"
            title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
            price={11.96}
            image="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._AC_SY400_.jpg"
            rating={5}
          />
          <Product
            id="49538094"
            title="Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl"
            price={239.0}
            rating={4}
            image="https://m.media-amazon.com/images/I/61etD4-IrPL._AC_SL1200_.jpg"
          />
        </div>
        <div className="home__row">
          <Product
            id="4903850"
            title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
            price={199.99}
            rating={3}
            image="https://m.media-amazon.com/images/I/611HoD6kGCL._AC_SL1500_.jpg"
          />

          <Product
            id="23445930"
            title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
            price={98.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/61u48FEs0rL._AC_SL1000_.jpg"
          />

          <Product
            id="90829332"
            title="Samsung LC49RG90SSUXEN"
            price={598.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/71o8pCQlSNL._AC_SL1500_.jpg"
          />
        </div>

        <div className="home__row">
          {
            <Product
              id="4903850"
              title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
              price={199.99}
              rating={3}
              image="https://m.media-amazon.com/images/I/816plc018HL._AC_SL1500_.jpg"
            />
          }
        </div>
      </div>
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4692387224099447"
        crossorigin="anonymous"
      ></script>
      <AdSense.Google client="ca-pub-4692387224099447" slot="7806394673" />
    </div>
  );
}

export default Home;
